import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PermissionsEnum } from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-token-load-tabs',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  templateUrl: './token-load-tabs.component.html',
  styleUrl: './token-load-tabs.component.scss',
})
export class TokenLoadTabsComponent {
  PermissionsEnum = PermissionsEnum;

  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}

  isActive(tab: string) {
    return this.router.url.includes(tab);
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }
}
